<div class="booking-create-cancel">
  <div class="booking-create-cancel__body">
    <div class="booking-create-cancel__summary sf-section">
      @if (service && service.image && service.name) {
        <app-image
          class="booking-create-cancel__summary-image"
          [src]="service.image"
          [alt]="service.name"
          preset="card"
          aspectRatio="1"
          [sizes]="'380px'"
          [width]="380"
          [height]="380"
        ></app-image>
      }
      <div class="booking-create-cancel__summary-details">
        <div class="booking-create-cancel__summary-header">
          @if (service && service.name) {
            <h3>{{ service.name }}</h3>
          }
          <div class="tag tag--red">
            {{ 'marketplace.booking.create.cancel.status' | transloco }}
          </div>
        </div>

        @if (billingInfo) {
          <div class="booking-create-cancel__summary-table">
            @if (billingInfo.publicPrice) {
              <div class="booking-create-cancel__summary-row">
                <span>{{ 'marketplace.booking.create.success.summary.amount' | transloco }}</span>
                <span>{{ billingInfo.publicPrice | currency:'EUR' }}</span>
              </div>
              @if (billingInfo.discount) {
                <div class="booking-create-cancel__summary-row">
                  <span>{{ 'service.pricing.discount' | transloco }}</span>
                  <span>-{{ billingInfo.discount | currency:'EUR' }}</span>
                </div>
              }
              @if (billingInfo.publicPrice !== null && billingInfo.publicPrice !== undefined) {
                <div class="booking-create-cancel__summary-row booking-create-cancel__summary-row--total">
                  <span>{{ 'marketplace.booking.create.success.summary.total' | transloco }}</span>
                  <strong>{{ (billingInfo.publicPrice - (billingInfo.discount ?? 0)) | currency:'EUR' }}</strong>
                </div>
              }
              <p class="booking-create-cancel__summary-note">{{ 'marketplace.booking.create.cancel.no-charge' | transloco }}</p>
            } @else if (service && service.publicPrice) {
              <div class="booking-create-cancel__summary-row booking-create-cancel__summary-row--total">
                <span>{{ 'marketplace.booking.create.success.summary.total' | transloco }}</span>
                <strong>{{ (service.publicPrice) | currency:'EUR' }}</strong>
              </div>
              <p class="booking-create-cancel__summary-note">{{ 'marketplace.booking.create.cancel.no-charge' | transloco }}</p>
            }
          </div>
        }

        @if (bookingId && photographerSlug && serviceId) {
          <button class="button button--primary button--full-width" [routerLink]="['/photographer', photographerSlug, serviceId, 'book', bookingId]">
            {{ 'marketplace.booking.create.cancel.try-again.cta.label'|transloco}}
            <i class="fa-solid fa-arrow-right"></i>
          </button>
        } @else if (photographerSlug && serviceId) {
          <button class="button button--primary button--full-width" [routerLink]="['/photographer', photographerSlug, serviceId, 'book']">
            {{ 'marketplace.booking.create.cancel.try-again.cta.label'|transloco}}
            <i class="fa-solid fa-arrow-right"></i>
          </button>
        }
      </div>
    </div>

    <div class="booking-create-cancel__actions">
      <div class="booking-create-cancel__title">
        <h1>{{'marketplace.booking.create.cancel.title'|transloco}}</h1>
      </div>
      <p class="booking-create-cancel__subtitle">
        {{'marketplace.booking.create.cancel.subtitle'|transloco}}
      </p>

      <section class="booking-create-cancel__next sf-section">
        <h2 class="sf-section__title">{{ 'marketplace.booking.create.cancel.next.title' | transloco }}</h2>
        <p class="sf-section__subtitle">{{ 'marketplace.booking.create.cancel.next.subtitle' | transloco }}</p>
        <ol class="booking-create-cancel__steps">
          <li class="booking-create-cancel__step">
            <i class="fa-solid fa-credit-card"></i>
            <div>
              <h4>{{ 'marketplace.booking.create.cancel.next.steps.card.title' | transloco }}</h4>
              <p>{{ 'marketplace.booking.create.cancel.next.steps.card.text' | transloco }}</p>
            </div>
          </li>
          <li class="booking-create-cancel__step">
            <i class="fa-solid fa-wallet"></i>
            <div>
              <h4>{{ 'marketplace.booking.create.cancel.next.steps.method.title' | transloco }}</h4>
              <p>{{ 'marketplace.booking.create.cancel.next.steps.method.text' | transloco }}</p>
            </div>
          </li>
          <li class="booking-create-cancel__step">
            <i class="fa-solid fa-headset"></i>
            <div>
              <h4>{{ 'marketplace.booking.create.cancel.next.steps.support.title' | transloco }}</h4>
              <p>{{ 'marketplace.booking.create.cancel.next.steps.support.text' | transloco }}</p>
            </div>
          </li>
        </ol>
      </section>

      <div class="booking-create-cancel__cta-row">
        @if (photographerSlug && serviceId) {
          <button class="button button--primary" [routerLink]="['/photographer', photographerSlug, serviceId, 'book']">
            {{'marketplace.booking.create.cancel.try-again.cta.label'|transloco}}
            <i class="fa-solid fa-arrow-right"></i>
          </button>
        }
        <a class="button button--white" href="mailto:contact@shutterflow.io">
          {{ 'marketplace.booking.create.cancel.support' | transloco }}
        </a>
      </div>
    </div>
  </div>
</div>
